<template>
  <Header_AS @on-change-main-page="getMainPageData()" />

  <!-- Our Culture Banner -->
  <section>
    <div class="banner-home-header">
      <div class="container">
        <div
          class="img-banner-home-header"
          :style="{ backgroundImage: `url(${fondoCultura})` }"
        ></div>
      </div>

      <div class="sobrefondo"></div>
      <div class="container px-5 container-banner-img">
        <div class="stack-badges">
          <img
            v-if="!isMobile"
            src="@/assets/talento_agv/img/home/Sellos GPTW-02.webp"
            alt="Certificado"
            class="certificado-badge-secundario d-none d-md-block"
          />
          <img
            v-if="!isMobile"
            src="@/assets/talento_agv/img/home/Sellos GPTW-03.webp"
            alt="Certificado"
            class="certificado-badge-secundario d-none d-md-block"
          />
          <img
            v-if="!isMobile"
            src="@/assets/talento_agv/img/home/Sellos GPTW-01.webp"
            alt="Certificado"
            class="certificado-badge d-none d-md-block"
          />
        </div>
      </div>

      <div class="container px-5 banner-text-wrapper">
        <div v-if="isMobile" class="stack-badges-mobile">
          <img
            src="@/assets/talento_agv/img/home/Sellos GPTW-02.webp"
            alt="Certificado"
            class="certificado-badge-mobile"
          />
          <img
            src="@/assets/talento_agv/img/home/Sellos GPTW-03.webp"
            alt="Certificado"
            class="certificado-badge-mobile"
          />
          <img
            src="@/assets/talento_agv/img/home/Sellos GPTW-01.webp"
            alt="Certificado"
            class="certificado-badge-mobile"
          />
        </div>
        <div class="banner-text-inner">
          <div :class="['text-start', { aos: !isMobile }]" :data-aos="!isMobile ? 'fade-up' : null">
            <h2 class="banner-title">
              {{ tituloUno }}
              <span class="banner-title-culture">{{ tituloDos }}</span>
              {{ tituloTres }}
            </h2>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Section win -->
  <section class="section-header-win">
    <div class="container px-5">
      <div class="aos" data-aos="fade-up">
        <div class="text-center">
          <h3
            class="section-header-win-header-title text-white py-3 d-flex justify-content-center align-items-center m-0"
          >
            <img src="@/assets/talento_agv/img/arrow.png" class="arrow-icon" />
            <span>{{ $t("¡El talento impulsa la estrategia!") }}</span>
            <img src="@/assets/talento_agv/img/arrow.png" class="arrow-icon" />
          </h3>
        </div>
      </div>
    </div>
  </section>


  <section class="section-content-win" :class="{ 'blur-background': dialog }">
    <div class="container px-5">
      <div class="row">
        <!-- IZQUIERDA -->
        <div class="col-12 col-md-6">
          <div class="container-content-win-left">
            <h4 class="mb-3 text-center">Vida en Agrovision</h4>

            <Carousel
              :wrap-around="true"
              :autoplay="carouselAutoplayValue"
            >
              <Slide
                v-for="(slide, idx) in seccionDosPublic.leftSlides"
                :key="slide.key || 'left-' + idx"
              >
                <div class="left-media-wrapper">
                  <!-- VIDEO -->
                  <div class="position-relative overflow-hidden" v-if="slide.type === 'video'">
                    <video
                      class="left-media video-background"
                      :src="slide.url"
                      autoplay
                      muted
                      loop
                      playsinline
                      @click="eventDialogVideo(slide.url)"
                    ></video>
                    <!-- botón play centrado -->
                    <span class="grid-item-play" @click="eventDialogVideo(slide.url)">
                      <i class="bx bx-play"></i>
                    </span>
                  </div>

                  <!-- IMAGEN -->
                  <img
                    v-else
                    class="left-media"
                    :src="slide.url"
                    alt="Vida en Agrovision"
                  />
                </div>
              </Slide>

              <template #addons>
                <Pagination class="custom-dots" />
              </template>
            </Carousel>
          </div>
        </div>


        <!-- DERECHA -->
        <div class="col-12 col-md-6">
          <div class="container-content-win-right">
            <h4 class="mb-3 text-center">¡Nuestras mejores postales!</h4>

            <Carousel :autoplay="3000" :wrap-around="true">
              <Slide
                v-for="(pair, idx) in seccionDosPublic.rightCarouselPairs"
                :key="'right-' + idx"
              >
                <div class="grid-container-right">
                  <div
                    v-for="(imgUrl, j) in pair"
                    :key="j"
                    class="grid-item"
                  >
                    <img
                      v-if="imgUrl"
                      :src="imgUrl"
                      class="right-img"
                      alt="Nuestras mejores postales"
                    />
                  </div>
                </div>
              </Slide>

              <template #addons>
                <Pagination class="custom-dots" />
              </template>
            </Carousel>
          </div>
        </div>

        <!-- REDES -->
        <div class="col-12 social-networks">
          <div class="icons-social-networks">
            <p class="title-social-networks">Visítanos:</p>
            <a
              href="https://www.facebook.com/TrabajaEnAgrovisionPeru"
              target="_blank"
              aria-label="Facebook"
            >
              <i class="fa-brands fa-facebook-f"></i>
            </a>
            <a
              href="https://www.tiktok.com/@agrovision.peru"
              target="_blank"
              aria-label="TikTok"
            >
              <i class="fa-brands fa-tiktok"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/agrovisionperu/mycompany/"
              target="_blank"
              aria-label="LinkedIn"
            >
              <i class="fa-brands fa-linkedin"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>


  <!-- Section our leaders -->
  <section class="section-header-our-leaders">
    <div class="container px-5">
      <div class="aos" data-aos="fade-up">
        <div class="text-center">
          <h3
            class="section-header-our-leaders-header-title text-white py-3 d-flex justify-content-center align-items-center m-0"
          >
            <img src="@/assets/talento_agv/img/arrow.png" class="arrow-icon" />
            <span>{{ $t("Líderes Agrovision") }}</span>
            <img src="@/assets/talento_agv/img/arrow.png" class="arrow-icon" />
          </h3>
        </div>
      </div>
    </div>
  </section>
  <section class="section-content-our-leaders">
    <div class="container px-5 py-4">
      <Carousel :autoplay="3000" :wrap-around="true">
        <Slide v-for="leader in dataTableLeaders_transform" :key="leader.id">
          <div class="grid-container-leaders">
            <div
              v-for="item in leader.items"
              :key="item.id"
              class="leader-card"
            >
              <div class="leader-card-inner">
                <!-- Foto -->
                <div class="leader-photo-wrapper">
                  <img
                    :src="item.s3_url"
                    class="leader-photo"
                    alt="Agrovision Leaders"
                  />
                </div>

                <!-- Pie gris con texto -->
                <div class="leader-info text-center">
                  <p class="leader-name">
                    {{ item.name }}
                  </p>
                  <p class="leader-position">
                    {{ item.work_position }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Slide>
      </Carousel>
    </div>
  </section>


  <!-- I choose to work in Agrovision-->
  <section class="section-choose-to-work">
    <div class="container px-5">
      <!-- Título -->
      <div class="row justify-content-center">
        <div class="col-12">
          <h3 class="section-choose-to-work-header-title text-center">
            {{ $t("Yo elijo trabajar en") }}
            <span class="bg-sky-blue">Agrovision</span>
          </h3>
        </div>
      </div>

      <!-- Contenido testimonios -->
      <div class="row align-items-start justify-content-center">
        <div
          class="col-12 col-md-6 p-4"
          v-for="item in dataTableTestimonials"
          :key="item.id_seccioncuatro_nc"
        >
          <!-- Texto -->
          <div
            class="aos"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <p
              class="testimonial-text"
              v-html="item.texto_testimonio"
            ></p>
          </div>

          <!-- Video -->
          <div
            class="position-relative w-100 video-wrapper"
          >
            <iframe
              :src="`${item.url_video}&title=0&byline=0&portrait=0`"
              frameborder="0"
              allow="autoplay; picture-in-picture; clipboard-write; fullscreen"
              class="frame-video-testimonials"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="section-footer-work-agrovision"></div>
  <!-- Footer -->
  <Footer_AS />
  <!-- Button work -->
  <Button_work_AS />

  <!-- Modal (vuetify) -->
  <v-dialog v-model="dialog" :width="dialogWidth">
    <v-card :class="['modal-transparent', { 'modal-fullscreen': isMobile }]">
      <!-- BOTÓN CERRAR -->
      <button
        class="close-btn"
        @click="closeModal"
        aria-label="Cerrar video"
        title="Cerrar"
      >
        ✕
      </button>

      <template #text>
        <div class="modal-video-wrapper">
          <video
            ref="modalVideo"
            :src="urlVideo"
            class="modal-video"
            controls
            autoplay
            playsinline
            :style="modalVideoStyle"
          ></video>
        </div>
      </template>
    </v-card>
  </v-dialog>
</template>
<script>
import { Carousel, Slide, Pagination } from "vue3-carousel";
import AOS from "aos";
import axiosIns from "@/plugins/axios.js";

import Button_work_AS from "./components/Button_work_AS.vue";
import Footer_AS from "./components/Footer_AS.vue";
import Header_AS from "./components/Header_AS.vue";

export default {
  components: {
    Button_work_AS,
    Carousel,
    Footer_AS,
    Header_AS,
    Pagination,
    Slide,
  },
  data() {
    return {

      dataTableAttributes: [],
      dataTableGallery: [],
      language: null,
      isMobile: window.innerWidth < 768,

      // SECCION 1 - NUESTRA CULTURA
      fondoCultura: null,
      tituloUno: '',
      tituloDos: '',
      tituloTres: '',

      // SECCION 2  - Nuestra Cultura - sección 2
      seccionDosPublic: {
        leftSlides: [],            // <-- carrusel izquierdo (img/video)
        rightCarouselPairs: [],    // ya lo usas
      },
      loadingSeccionDosPublic: false,



      // SECCION 3 - CARRUSEL VIDA EN AGV
      dataTableLeaders: [],              // lista plana que viene del backend
      dataTableLeaders_transform: [],    // lista agrupada en slides de 4

      // SECCION 4 - TESTIMONIOS
      dataTableTestimonials: [],

      // Modal logic
      dialog: false,
      urlVideo: "",
      autoplayMs: 4000,
    };
  },
  computed: {
    carouselAutoplayValue() {
      // Si hay más de 1 slide y autoplayMs es numérico, retorna autoplayMs
      // Si autoplayMs es false, retorna 0 (o false) para detener
      if (this.seccionDosPublic.leftSlides.length > 1 && this.autoplayMs) {
        return this.autoplayMs;
      }
      return 0;
    },
    dialogWidth() {
      return this.isMobile ? '100%' : '900';
    },
    modalVideoStyle() {
      if (this.isMobile) {
        return {
          width: 'calc(100vw - 32px)',
          height: 'calc(100vh - 120px)',
          maxWidth: '100vw',
          maxHeight: '100vh',
        };
      } else {
        return {
          width: '800px',
          height: '600px',
          maxWidth: '90vw',
          maxHeight: '80vh',
        };
      }
    }
  },
  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.onDialogClose();
      } else {
        this.$nextTick(() => {
          const mv = this.$refs.modalVideo;
          if (mv && mv.play) {
            mv.play().catch(()=>{});
          }
        });
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    this.getNuestraCulturaSeccionUnoNC()
    this.getSeccionDosPublic()
    this.getLeaders() 
    this.getNuestraCulturaSeccionCuatroNC()
    AOS.init({ duration: 1000 })
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {

    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },

    // --- MODAL LOGIC ---
    eventDialogVideo(url) {
      this.pauseAllBackgroundVideos();
      this.autoplayMs = false; // Detiene el carrusel
      this.urlVideo = url;
      this.dialog = true;
      document.body.style.overflow = 'hidden';
    },

    pauseAllBackgroundVideos() {
      const videos = document.querySelectorAll('.video-background');
      videos.forEach(v => {
        try {
          v.pause();
        } catch (e) {
          console.warn('Video background pause error:', e);
        }
      });
    },

    closeModal() {
      this.dialog = false;
      this.$nextTick(() => {
        const mv = this.$refs.modalVideo;
        if (mv) {
          try {
            mv.pause();
            mv.currentTime = 0;
          } catch (e) {
            console.warn('Modal video pause error:', e);
          }
        }
      });
    },

    onDialogClose() {
      this.autoplayMs = 4000; // Reinicia el carrusel
      
      // Reiniciar videos de fondo (muteados)
      const videos = document.querySelectorAll('.video-background');
      videos.forEach(v => {
        try {
          v.play().catch(()=>{});
        } catch (e) {
          console.warn('Video background play error:', e);
        }
      });

      const mv = this.$refs.modalVideo;
      if (mv) {
        try {
          mv.pause();
          mv.currentTime = 0;
        } catch (e) {
          console.warn('Modal video final pause error:', e);
        }
      }
      this.urlVideo = "";
      document.body.style.overflow = '';
    },

    // SECCION 1 - NUESTRA CULTURA
    async getNuestraCulturaSeccionUnoNC() {
      const yo = this
      try {
        const { data } = await axiosIns.get('/talentoagv/getNuestraCulturaSeccionUnoNC/')
        if (data?.is_error) throw new Error(data?.message || 'Error en el servidor')

        const result = data.result || []

        // Fondo dinámico desde el primer registro con imagen
        const fondo = result.find(r => r.s3_url)
        yo.fondoCultura = fondo ? fondo.s3_url : yo.fondoCultura

        // Palabras del título
        const palabras = result
          .map(r => (r.palabra || '').trim())
          .filter(Boolean)

        // Asignamos según posición
        yo.tituloUno = palabras[0] || ''
        yo.tituloDos = palabras[1] || ''
        yo.tituloTres = palabras[2] || ''
      } catch (error) {
        console.error('Error al obtener sección 1 NC:', error)
      }
    },
    // SECCION 2 - VIDA EN AGV

    async getSeccionDosPublic() {
      this.loadingSeccionDosPublic = true
      try {
        const { data } = await axiosIns.get('/talentoagv/getNuestraCulturaSeccionDosNC/')
        if (data?.is_error) throw new Error(data?.message || 'Error en servidor')

        const rows = Array.isArray(data?.result) ? data.result : []

        // 1) IZQUIERDA: carrusel mixto (video e imagen)
        const leftSlides = []
        for (const r of rows) {
          // primero el video si existe
          if (r.s3_video_url) {
            leftSlides.push({
              type: 'video',
              url: r.s3_video_url,
              key: `v-${r.id_secciondos_nc}-${r.s3_video_url}`,
            })
          }
          // luego la imagen principal si existe
          if (r.s3_url) {
            leftSlides.push({
              type: 'image',
              url: r.s3_url,
              key: `i-${r.id_secciondos_nc}-${r.s3_url}`,
            })
          }
        }

        // 2) DERECHA: se mantiene como lo tenías
        const imgsSecundarias = []
        for (const r of rows) {
          if (r.s3_url_two) imgsSecundarias.push(r.s3_url_two)
        }
        const pairs = []
        for (let i = 0; i < imgsSecundarias.length; i += 2) {
          pairs.push([imgsSecundarias[i], imgsSecundarias[i + 1] || null])
        }

        this.seccionDosPublic.leftSlides = leftSlides
        this.seccionDosPublic.rightCarouselPairs = pairs
      } catch (err) {
        console.error('getSeccionDosPublic error:', err)
      } finally {
        this.loadingSeccionDosPublic = false
      }
    },

    // seccion 3 - líderes

    async getLeaders() {
      const yo = this
      yo.dataTableLeaders = []
      yo.dataTableLeaders_transform = []

      try {
        const { data } = await axiosIns.get('/talentoagv/getNuestraCulturaSeccionTresNC/')
        if (data?.is_error) {
          throw new Error(data?.message || 'Error al obtener líderes')
        }

        // 1. normalizamos lo que viene del backend
        const leadersRaw = Array.isArray(data.result) ? data.result : []

        // 2. mapeamos nombres de campos del backend -> frontend
        //    para que el template siga igual sin romper
        yo.dataTableLeaders = leadersRaw.map(l => ({
          id: l.id_secciondos_nc,
          name: l.nombre_lider,
          work_position: l.cargo_lider,
          s3_url: l.s3_url,            // imagen firmada lista para usar en <img>
        }))

        // 3. agrupamos en chunks de 3 para el carrusel
        yo.dataTableLeaders_transform = yo.groupArray(yo.dataTableLeaders, 3)

      } catch (err) {
        console.error('Error cargando líderes:', err)
      }
    },

    groupArray(arr, chunkSize = 3) {
      const result = []
      for (let i = 0; i < arr.length; i += chunkSize) {
        result.push({
          // cada slide tiene una prop "items" con hasta 3 líderes
          items: arr.slice(i, i + chunkSize),
        })
      }
      return result
    },


    // seccion 4 - testimonios
    async getNuestraCulturaSeccionCuatroNC() {
      try {
        const { data } = await axiosIns.get('/talentoagv/getNuestraCulturaSeccionCuatroNC/')
        if (data?.is_error) throw new Error(data?.message || 'Error en el servidor')

        this.dataTableTestimonials = Array.isArray(data.result) ? data.result : []
      } catch (err) {
        console.error(err)
        this.dataTableTestimonials = []
      }
    },
  },
};
</script>
<style scoped src="./styles/shared_AS.css"></style>
<style scoped src="./styles/nuestra_cultura_AS.css"></style>

<style>
.banner-title-culture {
  color: #00b8f1; /* tono celeste AGV */
}

.grid-container-leaders {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 3rem; /* separacion entre cards */
  padding-left: 1rem;
  padding-right: 1rem;
}

/* card completa */
.leader-card {
  display: flex;
  justify-content: center;
}

.leader-card-inner {
  background-color: #f5f5f5;            
  border-radius: 16px;                 
  width: 230px;                         
  overflow: hidden;                     
  box-shadow: 0 8px 24px rgba(0,0,0,0.2); 
  border: 1px solid rgba(255,255,255,0.15); 
  display: flex;
  flex-direction: column;
}

.leader-photo-wrapper {
  background-color: #1a1a1a; 
  padding: 1rem;
  border-radius: 16px 16px 0 0;
  background-clip: padding-box;
}

/* imagen */
.leader-photo {
  width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
  display: block;
}

/* bloque gris con el texto */
.leader-info {
  background-color: #d9d9d9;   /* gris del footer en la maqueta */
  padding: 0.75rem 1rem;
  border-radius: 0 0 16px 16px;
  min-height: 90px;            
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* nombre */
.leader-name {
  font-size: 0.8rem;
  font-weight: 500;
  color: #000;
  line-height: 1.2;
  margin-bottom: 0.4rem;
  text-align: center;
  word-break: break-word;
  white-space: normal;
}

/* cargo */
.leader-position {
  font-size: 0.7rem;
  font-weight: 400;
  color: #000;
  line-height: 1.2;
  margin-bottom: 0;
  text-align: center;
  word-break: break-word;
  white-space: normal;
}

/* responsive en pantallas chicas (2 por fila, luego 1) */
@media (max-width: 992px) {
  .grid-container-leaders {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 2rem;
    justify-items: center;
  }
}

@media (max-width: 576px) {
  .grid-container-leaders {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}


.section-choose-to-work {
  background-color: #fff; /* en tu captura es fondo blanco */
  padding-top: 2rem;
  padding-bottom: 2rem;
}

/* Título principal */
.section-choose-to-work-header-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #000;
  margin-bottom: 2rem;
  line-height: 1.3;
}

.section-choose-to-work-header-title .bg-sky-blue {
  color: #00a3ff; /* celeste del "Agrovision" en tu imagen */
}

/* Texto del testimonio */
.testimonial-text {
  font-size: 0.95rem;
  line-height: 1.4;
  color: #000;
  font-weight: 500;
  margin-bottom: 1.5rem;
  max-width: 480px; 
  text-align: left;
  white-space: pre-line; 
}

.video-wrapper {
  position: relative;
  width: 100%;
  max-width: 480px; 
  padding-top: 55%; 
  margin-top: 2rem;
  background: #000; 
  border-radius: 4px;
  overflow: hidden;
}

.frame-video-testimonials {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

/* Responsive tweaks */
@media (max-width: 768px) {
  .section-choose-to-work-header-title {
    font-size: 1.3rem;
  }
  .testimonial-text {
    font-size: 0.9rem;
  }
}

.section-content-win .row {
  align-items: flex-start;
  justify-content: center;
  row-gap: 2rem; 
}

@media (min-width: 992px) {
  .section-content-win .row {
    flex-wrap: wrap;  
    row-gap: 2rem;    
  }

  .section-content-win .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .section-content-win .social-networks {
    flex: 0 0 100%;
    max-width: 100%;
    order: 3;                
    display: flex;
    justify-content: center;
  }
}

.container-content-win-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.left-media-wrapper {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: #000;
  height: auto;
  max-height: none;
}

@media (min-width: 992px) {
  .left-media-wrapper {
    height: 550%;      
    max-height: 550px;
  }
}

.left-media {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center;
}


.container-content-win-left .custom-dots {
  margin-top: 12px;
}


.left-media {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.container-content-win-left .custom-dots {
  margin-top: 16px;
}

.container-content-win-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.grid-container-right {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: auto;
}

.grid-container-right .grid-item {
  border-radius: 12px;
  overflow: hidden;
  background: #000;
}

.right-img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
}

.container-content-win-right .custom-dots {
  margin-top: 16px;
}

/* --- FIN SECCIÓN 2 --- */
/* --- MODAL STYLES --- */
.blur-background {
  filter: brightness(0.18);
  transition: filter 0.3s ease;
  pointer-events: none;
}

.modal-transparent {
  background: transparent;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 36px;
  height: 36px;
  background-color: #ffffff !important;
  color: #000000 !important;
  border: none;
  border-radius: 50%;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s ease;
}
.close-btn:active {
  transform: scale(0.9);
}

.modal-fullscreen {
  width: 100% !important;
  height: 100% !important;
  margin: 0;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-video-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.modal-video {
  display: block;
  border-radius: 12px;
  object-fit: contain;
  background: #040404;
  max-width: 100%;
  max-height: 100%;
  /* For desktop we use the inline styles computed (800x600). For mobile the computed styles use vw/vh */
}

.grid-item-play {
  position: absolute;
  inset: 0;
  margin: auto;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(255,255,255,0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  cursor: pointer;
  transition: transform .2s ease, background .2s ease;
  z-index: 2;
}
.grid-item-play:hover {
  transform: scale(1.1);
  background: rgba(255,255,255,1);
}

@media (max-width: 576px) {
  .modal-video-wrapper {
    padding: 8px;
  }
  .modal-video {
    border-radius: 8px;
  }
  .close-btn {
    width: 40px;
    height: 40px;
    font-size: 17px;
  }
}

</style>
